/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react';
import {Table, TableColumnsType} from "antd";
import dayjs from "dayjs";
import {BaechaUpdateHistoryItem} from "../../../BaechaList2.interface";
import {formatKorDate} from "../../../../../util/date";
import {fetchBaechaUpdateHistoryAPI} from "../../../../../api/baechaAPI";
import styles from "./TabBaechaUpdateHistory.module.scss";

interface TabBaechaUpdateHistoryProps {
	baechaId?: string;
}

const TabBaechaUpdateHistory = ({ baechaId }: TabBaechaUpdateHistoryProps) => {
	const [historyList, setHistoryList] = useState<any[]>([]);

	useEffect(() => {
		if (baechaId) {
			fetchBaechaUpdateHistoryAPI(baechaId)
				.then((res) => {
					const sorted = res.slice().sort((a: any, b: any) => dayjs(a.createDate).valueOf() - dayjs(b.createDate).valueOf())
					setHistoryList(sorted);
				})
				.catch((e) => console.error(e));
		}
	}, [baechaId]);

	const columns: TableColumnsType<BaechaUpdateHistoryItem> = [
		{
			title: '생성일시',
			dataIndex: 'createDate',
			key: 'createDate',
			width: 30,
			align: 'center',
			render: (text: string) => (
				<div style={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
					{formatKorDate(text)} {dayjs(text).format('HH:mm')}
				</div>
			)
		},
		{
			title: '메시지',
			dataIndex: 'message',
			key: 'message',
			width: 50,
			align: 'center',
			render: (text: string) => (<div style={{ textAlign: 'left', whiteSpace: 'nowrap' }}>{text}</div>)
		},
	];

	return (
		<>
			<Table
				bordered
				size='small'
				style={{ tableLayout: 'fixed', width: '100%' }}
				scroll={{ x: 'max-content' }}
				pagination={false}
				dataSource={historyList.map((row) => ({...row, key: row.id}))}
				columns={columns}
				rowClassName={(record, index) => (index % 2 === 0 ? styles.evenRow : styles.oddRow )}
			/>
		</>
	);
};

export default TabBaechaUpdateHistory;
